import { resolveComponent as t, openBlock as p, createBlock as d, withCtx as n, createVNode as s, renderSlot as i } from "vue";
/* empty css                    */
import c from "./design-system.es128.js";
import m from "./design-system.es37.js";
/* empty css                    */
/* empty css                    */
import u from "./design-system.es106.js";
/* empty css                    */
/* empty css                    */
import { useMenu as _ } from "./design-system.es293.js";
/* empty css                    */
/* empty css                    */
const f = {
  name: "DsMenuGroupHeader",
  components: {
    Box: m,
    DsText: u
  },
  setup() {
    const { dense: e } = _();
    return { dense: e };
  }
};
function l(e, g, x, o, B, h) {
  const r = t("DsText"), a = t("Box");
  return p(), d(a, {
    "padding-top": o.dense ? "spacing-150" : "spacing-250",
    "padding-bottom": o.dense ? "spacing-050" : "spacing-150",
    "padding-x": "spacing-200",
    class: "ds-menu-group-header"
  }, {
    default: n(() => [
      s(r, {
        variant: o.dense ? "headline-5" : "headline-4",
        as: "div"
      }, {
        default: n(() => [
          i(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["variant"])
    ]),
    _: 3
  }, 8, ["padding-top", "padding-bottom"]);
}
const N = /* @__PURE__ */ c(f, [["render", l], ["__scopeId", "data-v-bcac0a17"]]);
export {
  N as default
};
//# sourceMappingURL=design-system.es73.js.map
